class FCWAPopup {
    constructor({
                    popupSelector = '.fc-wa-popup',
                    innerSelector = '.fc-wa-popup-inner',
                    closeSelector = '.fc-wa-popup-close',
                    delay = 10000,
                    sessionKey = 'fcWaPopupShown'
                } = {}) {
        this.popup = document.querySelector(popupSelector);
        this.popupInner = document.querySelector(innerSelector);
        this.closeButton = document.querySelector(closeSelector);
        this.delay = delay;
        this.sessionKey = sessionKey;

        if (!this.popup || !this.popupInner || !this.closeButton) {
            return;
        }

        this.init();
    }

    init() {
        if (sessionStorage.getItem(this.sessionKey)) {
            return;
        }

        // Delay showing popup
        setTimeout(() => this.showPopup(), this.delay);

        // Close on close button
        this.closeButton.addEventListener('click', (e) => {
            e.stopPropagation();
            this.hidePopup();
        });

        // Close on outside click
        document.addEventListener('click', (e) => this.handleOutsideClick(e));
    }

    showPopup() {
        this.popup.classList.add('is-open');
        sessionStorage.setItem(this.sessionKey, 'true');
    }

    hidePopup() {
        this.popup.classList.remove('is-open');
    }

    handleOutsideClick(e) {
        if (!this.popup.classList.contains('is-open')) return;

        const isClickInside = this.popupInner.contains(e.target);
        const isCloseButton = this.closeButton.contains(e.target);

        if (!isClickInside && !isCloseButton) {
            this.hidePopup();
        }
    }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    new FCWAPopup();
});
